import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import { parseIconType } from '../../../utils/normalizers/parseIconByNotificationType';
import EmptyIcon from '../../atoms/icons/EmptyIcon';

interface IRealTimelineCardStyle {
  data?: {
    type:
      | any
      | 'Available'
      | 'Disconnected'
      | 'Connected'
      | 'StationBooted'
      | 'TransactionStarted'
      | 'TransactionEnded'
      | 'Failure';
    title: string;
    message: string;
  }[];
}

const RealTimelineCardStyle: React.FC<IRealTimelineCardStyle> = ({ data }) => {
  return (
    <Div>
      <div className='header'>Eventos</div>
      {!data?.length ? (
        <div className='card'>
          <EmptyIcon size={15} className='empty_icon' />
          <div className='message'>{T('There are no event records')}</div>
        </div>
      ) : (
        data.map((noti, index) => (
          <div key={index + 'noti'} className='card'>
            <div className='icon'> {parseIconType(noti.type, 12)} </div>
            <div className='title'> {noti.title} </div>
            <div className='message'> {noti.message} </div>
          </div>
        ))
      )}
    </Div>
  );
};

export default RealTimelineCardStyle;

const Div = styled.div`
  width: 20%;
  height: calc(100% - 10px);
  overflow-y: scroll;
  overflow-x: hidden;

  .header {
    position: sticky;
    top: -1px;
    margin-top: -1px;
    left: 0;
    padding-top: 3px;
    z-index: 3;
    height: 80px;
    background-image: linear-gradient(#fff, rgba(255, 255, 255, 0));
    margin-bottom: -50px;
    font-size: 12px;
    font-weight: 600;
  }

  .card {
    background-color: #fff;
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.1);
    /* height: 30px; */
    width: calc(100% - 25px);
    margin: 3px auto 3px 3px;
    border-radius: 8px;
    color: #555;
    display: grid;
    align-items: center;
    grid-template-columns: 35px 1fr;
    padding: 6px 10px 6px 0;

    .empty_icon {
      margin: 0 10px;
    }

    .icon {
      grid-column: 1;
      grid-row: span 2;
      align-self: center;
      justify-self: center;
    }

    .title {
      font-size: 9px;
      width: max-content;
    }

    .message {
      font-weight: 400;
      font-size: 12px;
    }
  }
`;
